import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const TextAlignFull = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='TextAlignFull' {...props}>
    <rect x='0.46' y='3.06' width='23.08' height='2.18' /><rect x='0.46' y='8.29' width='23.08' height='2.18' /><rect x='0.46' y='13.53' width='23.08' height='2.18' /><rect x='0.46' y='18.76' width='15.81' height='2.18' />
  </StyledIcon>
);
